module.exports = __webpack_public_path__ + "img/logo.b5aec4b0.svg";